import React from "react";
import { useNavigate } from "react-router-dom";

import { FooterStyles } from "./FooterStyles";
import { useTheme } from "../../../providers/ThemeContext";
import { useI18n } from "../../../languages/providers/I18nProvider";
import { footerKeys, footerData } from "./FooterContent";
import stylesCss from "./footer.module.css";
import { HashLink } from "react-router-hash-link";
import { useLangPath } from "../../../hooks/useLangPath";

const FooterServices = () => {
  const { theme } = useTheme();
  const { t } = useI18n();
  const s = FooterStyles(theme);
  const lp = useLangPath();

  return (
    <div>
      <div style={s.colTitle}>{t(footerKeys.servicesTitle)}</div>

      {footerData.services.map((item) => (
        <HashLink
          key={item.key}
          to={lp(item.to)}
          className={stylesCss.footerLink}
          smooth
        >
          {t(item.key)}
        </HashLink>
      ))}
    </div>
  );
};

export default FooterServices;
